import { RemirrorManager } from '@remirror/core'
import {
  IframeExtension,
  BlockquoteExtension,
  DocExtension,
  GapCursorExtension,
  HardBreakExtension,
  HorizontalRuleExtension,
  ImageExtension,
  LinkExtension,
  ListItemExtension,
  ParagraphExtension,
  TableRowExtension,
  TableCellExtension,
  TableExtension,
  StrikeExtension,
  SubExtension,
  SupExtension,
  TextExtension,
  TextCaseExtension,
  TextColorExtension,
  TextHighlightExtension,
  TrailingNodeExtension,
  UnderlineExtension,
  HeadingExtension,
  NodeFormattingExtension,
  BulletListExtension,
  OrderedListExtension,
  CodeExtension,
  CodeBlockExtension,
} from 'remirror/extensions'
import {
  prosemirrorNodeToDom,
  RemirrorJSON,
  createDocumentNode,
} from 'remirror'

import BoldExtension from '../../extensions/remirror-extension/bold-extension'
import ItalicExtension from '../../extensions/remirror-extension/italic-extension'
import { MathInlineExtension } from '../../extensions/katex/katex'
import KeyValueBlockExtension from '../../extensions/key-value-block/key-value-block'
import { CommentHighlightExtension } from '../../extensions/pepper-annotation-extension/pepper-annotation-extension'
import KeyValueBlockExtensionWrapper from '../../extensions/key-value-block/key-value-block-wrapper'

export function generateHtmlFromJSON(content?: RemirrorJSON) {
  if (!content) return ''

  if (Object.keys(content).length === 0) return ''

  const manager = RemirrorManager.create([
    new NodeFormattingExtension({}),
    new HeadingExtension({}),
    new BlockquoteExtension(),
    new BoldExtension({}),
    new DocExtension({}),
    new GapCursorExtension(),
    new HardBreakExtension(),
    new HorizontalRuleExtension({}),
    new ImageExtension({}),
    new ItalicExtension(),
    new LinkExtension({}),
    new ListItemExtension({}),
    new ParagraphExtension(),
    new StrikeExtension(),
    new SubExtension(),
    new SupExtension(),
    new TextExtension(),
    new TextCaseExtension({}),
    new TextColorExtension({}),
    new TextHighlightExtension({}),
    new MathInlineExtension(),
    new TrailingNodeExtension({}),
    new UnderlineExtension(),
    new TableRowExtension(),
    new TableCellExtension(),
    new TableExtension({}),
    new IframeExtension({ enableResizing: false }),
    new BulletListExtension({}),
    new OrderedListExtension(),
    new CommentHighlightExtension({
      defaultHighlight: 'rgba(255, 202, 51, 0.4)',
    }),
    new CodeExtension(),
    new CodeBlockExtension({}),
    new KeyValueBlockExtensionWrapper(),
    new KeyValueBlockExtension(),
  ])

  const node = createDocumentNode({ content, schema: manager.schema })
  const element = prosemirrorNodeToDom(node)

  const tempHTMLElement = document.createElement('div')
  tempHTMLElement.append(element)
  const html = tempHTMLElement.innerHTML
  tempHTMLElement.remove()
  return html
}
